// @file Team permissions settings store
import window from '@@/bits/global'
import { useSettingsTeamPermissionsMembersStore } from '@@/pinia/settings_team_permissions_members'
import type { Library } from '@@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

enum TeamPermissionsSettingsTab {
  Members = 'members',
}

const teamPermissionsSettingsTabToHash = {
  [TeamPermissionsSettingsTab.Members]: '#members',
}
const hashToTeamPermissionsSettingsTab = Object.fromEntries(
  Object.entries(teamPermissionsSettingsTabToHash).map(([k, v]) => [v, k as TeamPermissionsSettingsTab]),
)

const getTeamPermissionsSettingsTabFromHash = (): TeamPermissionsSettingsTab => {
  return hashToTeamPermissionsSettingsTab[window.location.hash] ?? TeamPermissionsSettingsTab.Members
}

export const useSettingsTeamPermissionsStore = defineStore('settingsTeamPermissions', () => {
  const settingsTeamPermissionsMembersStore = useSettingsTeamPermissionsMembersStore()

  // State
  const currentTab = ref<TeamPermissionsSettingsTab>(getTeamPermissionsSettingsTabFromHash())
  const visitedTabs = ref<Record<TeamPermissionsSettingsTab, boolean>>({
    [TeamPermissionsSettingsTab.Members]: false,
  })
  const library = ref<Library>()

  // Getters

  // Actions
  async function initialize(libraryObject?: Library): Promise<void> {
    visitedTabs.value = {
      [TeamPermissionsSettingsTab.Members]: false,
    }
    library.value = libraryObject
    await initializeTab()
  }

  async function initializeTab(): Promise<void> {
    visitedTabs.value[currentTab.value] = true
    switch (currentTab.value) {
      case TeamPermissionsSettingsTab.Members:
        await settingsTeamPermissionsMembersStore.initialize(library.value)
        break
    }
  }

  function setTeamPermissionsSettingsTabFromHash(): void {
    currentTab.value = getTeamPermissionsSettingsTabFromHash()
    const isCurrentTabInitialized = visitedTabs.value[currentTab.value]

    if (!isCurrentTabInitialized) {
      void initializeTab()
    }
  }

  return {
    // State
    currentTab,
    visitedTabs,

    // Actions
    initialize,
    setTeamPermissionsSettingsTabFromHash,
  }
})

export { TeamPermissionsSettingsTab, teamPermissionsSettingsTabToHash }
